import { useMutation } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from '../gql';

export const UPSERT_ENTITIES_BROKERAGE_AGENTSYNC = graphql(`
  mutation upsertEntityAgentSync($entityNpn: String!) {
    upsertEntityFromNpn(entityNpn: $entityNpn) {
      uuid
    }
  }
`);
export function useUpsertBrokerageAgentSync() {
  const [upsertEntity, { loading, error, data }] = useMutation(
    UPSERT_ENTITIES_BROKERAGE_AGENTSYNC,
    {
      fetchPolicy: 'network-only',
    }
  );

  const brokerages = useMemo(() => {
    if (!data || !data.upsertEntityFromNpn) return null;
    return { uuid: data.upsertEntityFromNpn.uuid };
  }, [data]);

  return {
    error,
    loading,
    data,
    upsertEntity,
    brokerages,
  };
}
